import apiClient from "../api/client";
import { Role } from "../types/types";

export const getActiveRoles = () =>
  apiClient.get<Role[]>("/api/Role/GetActiveRoles");

export const getRoles = () =>
  apiClient.get<Role[]>("/api/Role/GetAllRoles");

export const createRole = (roleName: string) =>
  apiClient.post("/api/Role/CreateRole", { roleName });

export const toggleRoleStatus = (roleGuid: string) =>
  apiClient.put(`/api/Role/ToggleRoleStatus/${roleGuid}`);